<template>
  <CFooter :fixed="false">
    <div>
      <span class="ml-1">Hệ thống cơ sở dữ liệu quốc gia về tài sản công</span>
    </div>
    <div class="ml-auto">
        <span class="mr-1">&copy; <b>2020</b> - Bộ Tài chính</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
